import { TlearningAccess } from './learningAccess';
import { TlearningAssetsVideo } from './learningAssetsVideo';
import { TlearningCategory, initialLearningCategory } from './learningCategory';

export interface Tlearning {
	id?: number;
	uniqueId?: string;
	name: string;
	learningCategory: TlearningCategory;
	slug: string;
	content: string;
	content_plain: string;
	thumbnail: string;
	author: string;
	active: boolean;
	learningAssetsVideos: TlearningAssetsVideo[];
	learningAccesses: TlearningAccess[];
}

export const initialLearning: Tlearning = {
	name: '',
	learningCategory: initialLearningCategory,
	slug: '',
	content: '',
	content_plain: '',
	thumbnail: '',
	author: '',
	active: false,
	learningAssetsVideos: [],
	learningAccesses: [],
};
